export default function CWhile() {
  return <h2>C While</h2>;
}
